/* istanbul ignore file */
import React, { useState } from 'react';
import { Button } from 'framework/ui/mui-builder';
import { useFieldHelper } from 'framework/ui/field';
import { useArtifactDownloadHelper } from 'domain/shared/artifact';
import { InputLoader } from 'framework/ui/mui-builder';

type DownloadArtifactButtonProps = {
  source: string;
};

const DownloadArtifactButton = (props: DownloadArtifactButtonProps) => {
  const { getValue } = useFieldHelper<any>(props);
  const { download } = useArtifactDownloadHelper();
  const file = getValue();
  const [loading, setLoading] = useState(false);

  const onClick = async (e: any) => {
    e.currentTarget.blur();
    setLoading(true);
    await download(file?.id, file?.title);
    setLoading(false);
  };

  return file ? (
    <Button {...props} onClick={onClick} variant="outlined">
      Download
      {loading && <InputLoader sx={{ ml: 1 }} />}
    </Button>
  ) : null;
};

export default DownloadArtifactButton;
